module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image12.a52baad8.jpg";